import { render, staticRenderFns } from "./com_download.vue?vue&type=template&id=620f2794"
import script from "./com_download.vue?vue&type=script&lang=js"
export * from "./com_download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports